import React,{useState}  from 'react'
import {Card, ContentLink, Title, Desc, Separador, Cont,Linkover} from './styles'

const EbookCard = ({cover,  id ,  source, title, res}) => {
    const [imgurl, setimgurl] = useState('./images/ico_descarga.svg');
    const handleMouseOver = async (val) => {
        if(val === 0){
            setimgurl('./images/ico_descarga.svg')
        } else if(val === 1){
            setimgurl('./images/ico_descarga_over.svg')
        } 
    }
    return (
        
        <Card id={id}>
                {
                    source.toLowerCase().startsWith('http') || source.toLowerCase().startsWith('https') ? (
                        <Cont><ContentLink>
                            <Linkover onMouseOver={() => handleMouseOver(1)} onMouseOut={() => handleMouseOver(0)}  title={title} target='_blank' rel='noopener noreferrer' href={`${source}`}>
                            <img
                                src={imgurl}
                                alt=""
                            />
                            <div>
                                <Title className="titlelink">
                                    {title}
                                </Title>
                                <Desc>
                                    {res}
                                </Desc>
                            </div>
                            </Linkover></ContentLink>
                        <Separador></Separador></Cont>
                    ):(
                        <Cont><ContentLink>
                        <Linkover onMouseOver={() => handleMouseOver(1)} onMouseOut={() => handleMouseOver(0)}  title={title} target='_blank' rel='noopener noreferrer' href={`${process.env.PUBLIC_URL}/${source}`}>
                            <img
                                src={imgurl}
                                alt=""
                            />
                            <div>
                                <Title>
                                    {title}
                                </Title>
                                <Desc>
                                    {res}
                                </Desc>
                            </div>
                        </Linkover>
                    </ContentLink>
                    <Separador></Separador></Cont>

                    )
                }

        </Card>

    )
}

export default EbookCard